import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberFormatter'
})
export class NumberFormatterPipe implements PipeTransform {

  transform(value: number | null | undefined): string {
    // Null or undefined check
    if (value == null) {
      return ''; // Or return a default message like 'N/A'
    }

    if (value >= 10000000) {
      return (value / 10000000).toFixed(1) + ' Cr';  // Crores for numbers over 1 crore
    } else if (value >= 100000) {
      return (value / 100000).toFixed(1) + ' Lac';  // Lacs for numbers over 1 lac
    } else if (value >= 1000) {
      return (value / 1000).toFixed(1) + 'K';  // Thousands for numbers over 1k
    }
    return value.toString();  // Return the number as is for smaller numbers
  }
}